import { render, staticRenderFns } from "./CaseInterventions.vue?vue&type=template&id=d8bbfd28&scoped=true&"
import script from "./CaseInterventions.vue?vue&type=script&lang=js&"
export * from "./CaseInterventions.vue?vue&type=script&lang=js&"
import style0 from "./CaseInterventions.vue?vue&type=style&index=0&id=d8bbfd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bbfd28",
  null
  
)

export default component.exports